module.exports = __webpack_public_path__ + "static/media/Group 252.b8323a45.svg";